import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { ACCOUNTING_HEADING_TYPE } from 'src/features/accountingHeaders/utils/types';
import { accountingHeadersMessages } from 'src/features/accountingHeaders/utils/messages';

export const ACCOUNTING_HEADER_TYPE_BADGE_MAP: Record<ACCOUNTING_HEADING_TYPE, BadgeOption> = {
    [ACCOUNTING_HEADING_TYPE.INCOME]: {
        label: accountingHeadersMessages.income,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [ACCOUNTING_HEADING_TYPE.ESTIMATE]: {
        label: accountingHeadersMessages.estimate,
        icon: ICON_MAP.CHECK,
        theme: 'blue',
    },
    [ACCOUNTING_HEADING_TYPE.EXPENSE]: {
        label: accountingHeadersMessages.expense,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
    [ACCOUNTING_HEADING_TYPE.BALANCE]: {
        label: accountingHeadersMessages.balance,
        icon: ICON_MAP.CHECK,
        theme: 'gray',
    },
};

export const ACCOUNTING_HEADER_TYPE_TRANSLATION_MAP: Record<ACCOUNTING_HEADING_TYPE, { id: string, defaultMessage: string}> = {
    [ACCOUNTING_HEADING_TYPE.INCOME]: accountingHeadersMessages.income,
    [ACCOUNTING_HEADING_TYPE.ESTIMATE]: accountingHeadersMessages.estimate,
    [ACCOUNTING_HEADING_TYPE.EXPENSE]: accountingHeadersMessages.expense,
    [ACCOUNTING_HEADING_TYPE.BALANCE]: accountingHeadersMessages.balance,
};
